import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/manager/accounts', params, query, config)
  },

  get(axios, params, query, config) {
    return api.get(axios, '/manager/accounts/:id', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/manager/accounts/:id', params, payload, config)
  },

  destroy(axios, params, config) {
    return api.delete(axios, '/manager/accounts/:id', params, config)
  },

  panel(axios, params, query, config) {
    return api.get(axios, '/manager/accounts/:id/panel', params, query, config)
  },

  uniqueIdentity(axios, params, query, config) {
    return api.get(axios, '/manager/accounts/unique_identity', params, query, config)
  },
}
